import { FinancialAccountNode } from '../../../services/orgs/interfaces';
import { replaceAccountRepresentative } from '../../../services/vault/stripeConnectAccount';
import {
  StripeEntities,
  UnitEntities,
} from '../../OrgConfirmation/submit/providerEntities';

type ProviderKycEntities = {
  stripeEntities?: Pick<StripeEntities, 'personId'>;
  unitEntities?: Pick<UnitEntities, keyof UnitEntities>;
};

export async function createProviderKycEntities({
  financialAccountNode,
  kycId,
}: {
  financialAccountNode: FinancialAccountNode;
  kycId: string;
}): Promise<ProviderKycEntities> {
  if (financialAccountNode.processor === 'STRIPE') {
    if (!financialAccountNode.acctId) {
      throw new Error(
        `financialAccountNode ${JSON.stringify(
          financialAccountNode,
        )} is missing acctId`,
      );
    }

    const personId = await replaceAccountRepresentative(
      financialAccountNode.acctId,
      kycId,
      financialAccountNode.stripeEnv,
    );

    return {
      stripeEntities: {
        personId,
      },
    };
  } else if (financialAccountNode.processor === 'UNIT') {
    throw new Error('OrgConfirmation unit not implemented');
  } else {
    throw new Error(`Unknown provider ${financialAccountNode.processor}`);
  }
}
